<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between ">
                        <div class=" d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">Scan QR Code</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <div class="row">
                            <div class="col-md-6">
                                <div style="font-size: 28px;">To use WhatsApp on your computer:</div>
                                <br>
                                <ol>
                                    <li style="margin-top: 18px;">Open WhatsApp on your phone</li>
                                    <li style="margin-top: 18px;">
                                        <span dir="ltr" class="i0jNr">Tap <strong><span dir="ltr" class="i0jNr">Menu
                                                    <span class="_30yMe"><svg height="24px" viewBox="0 0 24 24"
                                                            width="24px">
                                                            <rect fill="#f2f2f2" height="24" rx="3" width="24"></rect>
                                                            <path
                                                                d="m12 15.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5zm0-2c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5zm0-5c-.825 0-1.5-.675-1.5-1.5s.675-1.5 1.5-1.5 1.5.675 1.5 1.5-.675 1.5-1.5 1.5z"
                                                                fill="#818b90"></path>
                                                        </svg></span></span></strong> or <strong><span dir="ltr"
                                                    class="i0jNr">Settings <span class="_30yMe"><svg width="24"
                                                            height="24" viewBox="0 0 24 24">
                                                            <rect fill="#F2F2F2" width="24" height="24" rx="3"></rect>
                                                            <path
                                                                d="M12 18.69c-1.08 0-2.1-.25-2.99-.71L11.43 14c.24.06.4.08.56.08.92 0 1.67-.59 1.99-1.59h4.62c-.26 3.49-3.05 6.2-6.6 6.2zm-1.04-6.67c0-.57.48-1.02 1.03-1.02.57 0 1.05.45 1.05 1.02 0 .57-.47 1.03-1.05 1.03-.54.01-1.03-.46-1.03-1.03zM5.4 12c0-2.29 1.08-4.28 2.78-5.49l2.39 4.08c-.42.42-.64.91-.64 1.44 0 .52.21 1 .65 1.44l-2.44 4C6.47 16.26 5.4 14.27 5.4 12zm8.57-.49c-.33-.97-1.08-1.54-1.99-1.54-.16 0-.32.02-.57.08L9.04 5.99c.89-.44 1.89-.69 2.96-.69 3.56 0 6.36 2.72 6.59 6.21h-4.62zM12 19.8c.22 0 .42-.02.65-.04l.44.84c.08.18.25.27.47.24.21-.03.33-.17.36-.38l.14-.93c.41-.11.82-.27 1.21-.44l.69.61c.15.15.33.17.54.07.17-.1.24-.27.2-.48l-.2-.92c.35-.24.69-.52.99-.82l.86.36c.2.08.37.05.53-.14.14-.15.15-.34.03-.52l-.5-.8c.25-.35.45-.73.63-1.12l.95.05c.21.01.37-.09.44-.29.07-.2.01-.38-.16-.51l-.73-.58c.1-.4.19-.83.22-1.27l.89-.28c.2-.07.31-.22.31-.43s-.11-.35-.31-.42l-.89-.28c-.03-.44-.12-.86-.22-1.27l.73-.59c.16-.12.22-.29.16-.5-.07-.2-.23-.31-.44-.29l-.95.04c-.18-.4-.39-.77-.63-1.12l.5-.8c.12-.17.1-.36-.03-.51-.16-.18-.33-.22-.53-.14l-.86.35c-.31-.3-.65-.58-.99-.82l.2-.91c.03-.22-.03-.4-.2-.49-.18-.1-.34-.09-.48.01l-.74.66c-.39-.18-.8-.32-1.21-.43l-.14-.93a.426.426 0 00-.36-.39c-.22-.03-.39.05-.47.22l-.44.84-.43-.02h-.22c-.22 0-.42.01-.65.03l-.44-.84c-.08-.17-.25-.25-.48-.22-.2.03-.33.17-.36.39l-.13.88c-.42.12-.83.26-1.22.44l-.69-.61c-.15-.15-.33-.17-.53-.06-.18.09-.24.26-.2.49l.2.91c-.36.24-.7.52-1 .82l-.86-.35c-.19-.09-.37-.05-.52.13-.14.15-.16.34-.04.51l.5.8c-.25.35-.45.72-.64 1.12l-.94-.04c-.21-.01-.37.1-.44.3-.07.2-.02.38.16.5l.73.59c-.1.41-.19.83-.22 1.27l-.89.29c-.21.07-.31.21-.31.42 0 .22.1.36.31.43l.89.28c.03.44.1.87.22 1.27l-.73.58c-.17.12-.22.31-.16.51.07.2.23.31.44.29l.94-.05c.18.39.39.77.63 1.12l-.5.8c-.12.18-.1.37.04.52.16.18.33.22.52.14l.86-.36c.3.31.64.58.99.82l-.2.92c-.04.22.03.39.2.49.2.1.38.08.54-.07l.69-.61c.39.17.8.33 1.21.44l.13.93c.03.21.16.35.37.39.22.03.39-.06.47-.24l.44-.84c.23.02.44.04.66.04z"
                                                                fill="#818b90"></path>
                                                        </svg></span></span></strong> and select <strong>Linked
                                                Devices</strong></span>
                                    </li>
                                    <li style="margin-top: 18px;">Point your phone to this screen to capture the code
                                    </li>
                                </ol>
                                <br>
                                <div v-if="repairLoading">
                                    <br>
                                    <button class="btn btn-primary btn-block" disabled>
                                        <div class="spinner-border spinner" role="status"></div>
                                        Loading...
                                    </button>
                                </div>
                                <div v-else>
                                    <br>
                                    <button type="button" v-on:click="repairDevice"
                                        class="btn btn-primary btn-default btn-squared text-capitalize btn-block">
                                        Pindah Server <span class="badge badge-danger">New</span>
                                    </button>
                                </div>
                                <b>*Setelah klik pindah server harap tunggu qr hingga muncul atau refresh halaman</b>
                            </div>
                            <div class="col-md-6">
                                <center>
                                    <div v-if="isLoading" class="spinner-border spinner" role="status"></div>
                                    <div v-if="qrReady">
                                        <div class="alert alert-primary" role="alert">
                                            Silahkan Scan QR Code
                                        </div>
                                        <qrcode v-if="!isLoading" :value="qr" :options="{ width: 350 }"></qrcode>
                                        <hr>
                                        <button class="btn btn-success btn-block" v-on:click="toggleModal('pairing_code')">Pairing Code</button>
                                    </div>
                                    <div v-if="timeout">
                                        <div class="alert alert-danger" role="alert">
                                            Waktu Koneksi Habis
                                        </div>
                                        <button class="btn btn-primary btn-block" v-on:click="relogDevice">Minta QR
                                            Baru</button>
                                    </div>
                                </center>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal name="pairing_code" :height="'auto'" :adaptive="true" :scrollable="true">
            <div style="margin: 20px">
                <div v-if="!timeout">
                    <div class="alert alert-danger" role="alert" v-if="pairCodeError != ''">
                        {{ pairCodeError }}
                    </div>
                    <label>Nomor HP (dimulai dengan kode negara, misal : 628123456789)</label>
                    <input
                        type="number"
                        class="form-control"
                        v-model="phone"
                        required
                        placeholder="628123456789"
                        :readonly="pairCode != ''"
                    />
                    <br>
                    <div v-if="pairCode == ''">
                        <button
                            class="btn btn-success btn-block"
                            @click="getPairingCode"
                            :disabled="pairingCodeLoading"
                            >
                            <span v-if="pairingCodeLoading">
                                <i class="fa fa-spinner fa-spin"></i> Sedang memproses...
                            </span>
                            <span v-else>
                                Dapatkan Kode
                            </span>
                        </button>
                    </div>
                    <div v-else>
                        Pairing Code :
                        <center>
                            <h3><b>{{ pairCode }}</b></h3>
                        </center>
                    </div>
                </div>
                <div v-else>
                    <div class="alert alert-danger" role="alert">
                        Waktu Koneksi Habis, Silahkan Minta QR Baru Terlebih Dahulu
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isLoading: true,
                qrReady: false,
                timeout: false,
                qr: "",
                device_id: "",
                loop: true,
                reconnect: false,
                timeout_count: 0,
                interval: null,
                repairLoading: false,
                phone: "",
                pairingCodeLoading: false,
                pairCode: "",
                pairCodeError: ""
            }
        },
        beforeDestroy() {
            this.$root.$off("ws", this.fn);
            this.$root.$off("toggle_modal", this.fnToggleModal);

            clearInterval(this.interval)
        },
        mounted() {
            this.fnToggleModal = (param) => {
                this.toggleModal(param);
            }
            this.$root.$on("toggle_modal", this.fnToggleModal);

            this.device_id = this.$route.query.id
            this.loadData()

            this.interval = setInterval(this.loadData, 4000)
        },
        methods: {
            async getPairingCode(){
                try {
                    if(this.phone == ""){
                        this.pairCodeError = "Nomor HP tidak boleh kosong"
                        return
                    }
                    this.pairingCodeLoading = true
                    this.pairCodeError = ""
                    let pairingCode = await this.$store.dispatch("device_pairing_code", {
                        id: parseInt(this.device_id),
                        phone: this.phone
                    })

                    this.pairCode = pairingCode.data.data.pairCode
                    this.pairingCodeLoading = false
                } catch (error) {
                    this.pairingCodeLoading = false
                    this.pairCodeError = error.response.data.message
                }

            },
            async loadData() {
                try {
                    let detail = await this.$store.dispatch("device_detail", {
                        id: this.device_id
                    })
                    this.qr = detail.data.data.device.qr

                    if (detail.data.data.device.status == "connected") {
                        this.$toast.info("Device sudah terkoneksi")
                        this.$router.push("/device")
                    }

                    if (detail.data.data.device.qr != "timeout") {
                        this.timeout = false
                        this.qrReady = true
                        this.isLoading = false
                    }
                    if (detail.data.data.device.qr == "timeout" || detail.data.data.device.qr == "dc" || detail.data
                        .data.device.qr == null) {
                        this.timeout = true
                        this.qrReady = false
                    }

                    if (detail.data.data.device.qr == "timeout" && this.timeout_count >= 3) {
                        this.loop = false
                    } else if (detail.data.data.device.qr == "timeout") {
                        this.timeout_count += 1
                    }
                } catch (err) {
                    this.$toast.error(err.response.data.message)
                    this.$router.push("/device")
                }
            },
            async relogDevice() {
                try {
                    let response = await this.$store.dispatch('device_relog', {
                        id: parseInt(this.device_id)
                    })
                    this.isLoading = true
                    this.timeout = false
                    this.qrReady = false
                    this.$toast.success(response.data.message);
                    this.$toast.info("Mohon tunggu...");
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            async repairDevice() {
                this.repairLoading = true
                try {
                    let response = await this.$store.dispatch('device_move', {
                        id: parseInt(this.device_id),
                    })

                    // this.$router.push({ path: '/device/scan', query: { id: parseInt(response?.data?.data?.newID) } });
                    this.$router.go(0)
                    this.$toast.success(response.data.message);
                } catch (err) {
                    this.$toast.error(err.response.data.message);
                }
            },
            toggleModal(param) {
                this.$modal.toggle(param);
            },
        }
    }
</script>